import { type LocaleKey as flatpickrLocaleKey, localize as localizeFlatpickr } from "../lib/flatpickr";
import SessionPoll from "../lib/sessionPoll";

interface Arguments {
    sessionTimeout: number;
    flatpickrLocale: flatpickrLocaleKey;
    flatpickrDateFormat: string;
    flatpickrFirstDayOfWeek: number;
}

export const initMainPage = (args: Arguments): void => {
    // If this is not loaded in the top frame, redirect it.
    if (window !== window.top) {
        window.top.location.href = window.location.href;
    }

    new SessionPoll(args.sessionTimeout);

    const logoWink = () => {
        const logo = document.getElementById("pyrat-logo");
        logo.classList.add("wink");
        setTimeout(() => {
            logo.classList.remove("wink");
        }, 200);
    };

    setInterval(() => {
        const rnd = Math.round(Math.random() * 5000);
        setTimeout(logoWink, rnd);
    }, 6000);
    document.getElementById("pyrat-logo").addEventListener("mouseenter", logoWink);

    localizeFlatpickr(args.flatpickrLocale, args.flatpickrDateFormat, args.flatpickrFirstDayOfWeek);
};
